import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const buildStudyPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  // TODO: pass backend the study plan if one exists (edit)
  invoke: {
    id: "buildStudyPlan",
    src: "buildStudyPlan",
    onDone: [
      {
        target: "review_plan",
        actions: assign({ studyPlan: (_ctx, evt) => evt.data.plan }),
        cond: (ctx, _evt) => !ctx.isBlank
      },
      {
        target: "edit_plan",
        actions: assign<Context, DoneInvokeEvent<any>>({
          studyPlan: (_ctx, evt) => evt.data.plan
        }),
        cond: (ctx, evt) =>
          !ctx.isReadOnly &&
          ctx.isBlank &&
          ctx.studyPlan?.subType !== evt.data.plan.subType
      },
      {
        target: "edit_plan",
        actions: assign<Context, DoneInvokeEvent<any>>({
          studyPlan: (_ctx, evt) => evt.data.plan,
          snackbar: () => {
            return { message: "Study plan hours have been modified" }
          }
        }),
        cond: (ctx, evt) =>
          !ctx.isReadOnly &&
          ctx.isBlank &&
          ctx.studyPlan?.subType === evt.data.plan.subType
      },
      {
        // Fallback for read-only - always go to review_plan
        target: "review_plan",
        actions: assign({ studyPlan: (_ctx, evt) => evt.data.plan })
      }
    ],
    onError: {
      target: "#StudyPlan.study_plans_overview.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("newPlan", {
            errorReason: evt.data.message,
            messageData: ["create a new plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
